"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from "react";
import { FaArrowUp, FaWhatsapp } from "react-icons/fa";
export default function ScrollToTop() {
  const $ = _c(10);
  const [isVisible, setIsVisible] = useState(false);
  const circleRef = useRef(null);
  const frameRef = useRef(null);
  const circumference = 2 * Math.PI * 22;
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const updateScroll = () => {
        const totalHeight = document.documentElement.scrollHeight - window.innerHeight;
        const scroll = window.scrollY;
        setIsVisible(scroll > 100);
        if (totalHeight > 0 && circleRef.current) {
          const progress = Math.min(100, Math.max(0, scroll / totalHeight * 100));
          const offset = circumference - progress / 100 * circumference;
          circleRef.current.style.strokeDashoffset = `${offset}`;
        }
        frameRef.current = null;
      };
      const handleScroll = () => {
        if (frameRef.current === null) {
          frameRef.current = requestAnimationFrame(updateScroll);
        }
      };
      window.addEventListener("scroll", handleScroll, {
        passive: true
      });
      updateScroll();
      return () => {
        window.removeEventListener("scroll", handleScroll);
        if (frameRef.current !== null) {
          cancelAnimationFrame(frameRef.current);
        }
      };
    };
    t1 = [circumference];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  const scrollToTop = _temp;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <a href="https://wa.me/919924523136?text=Hi%20The%20Dezine%20team!%20I%27d%20like%20to%20inquire%20about%20your%20services.%20Could%20you%20please%20share%20more%20details%20and%20help%20me%20find%20the%20right%20solution%20for%20my%20requirements%3F" target="_blank" rel="noopener noreferrer" aria-label="Chat on WhatsApp (opens in a new tab)" className="relative isolate hidden h-10 w-10 xl:flex items-center justify-center rounded-full bg-linear-to-br from-[#25D366] to-[#169c49] text-white shadow-[0_4px_14px_rgba(22,163,74,0.25)] ring-1 ring-inset ring-white/25 hover:shadow-[0_6px_18px_rgba(22,163,74,0.35)] focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-green-600 motion-safe:transition-[box-shadow,transform] motion-safe:duration-300 motion-safe:hover:scale-105 motion-safe:active:scale-95 sm:h-11 sm:w-11"><span aria-hidden="true" className="pointer-events-none absolute inset-0 -z-10 rounded-full bg-[#25D366]/30 motion-safe:animate-[ping_2.5s_cubic-bezier(0,0,0.2,1)_infinite] motion-reduce:hidden" /><FaWhatsapp aria-hidden="true" className="size-5" /></a>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = `relative isolate transform transition-[opacity,transform] duration-500 ease-out ${isVisible ? "translate-y-0 scale-100 opacity-100" : "pointer-events-none translate-y-6 scale-75 opacity-0"}`;
  const t4 = isVisible ? 0 : -1;
  let t5;
  let t6;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <svg className="absolute h-full w-full -rotate-90" viewBox="0 0 50 50"><circle cx="25" cy="25" r={22} className="stroke-[#e8e5ff]" strokeWidth="3" fill="transparent" /><circle ref={circleRef} cx="25" cy="25" r={22} className="stroke-[#1d4ed8]" strokeWidth="3" strokeDasharray={circumference} strokeDashoffset={circumference} strokeLinecap="round" fill="transparent" /></svg>;
    t6 = <FaArrowUp className="z-10 text-[#1d4ed8] transition-transform duration-300 ease-out" />;
    $[3] = t5;
    $[4] = t6;
  } else {
    t5 = $[3];
    t6 = $[4];
  }
  let t7;
  if ($[5] !== t4) {
    t7 = <button type="button" onClick={scrollToTop} tabIndex={t4} aria-label="Scroll to top" className="group relative flex h-12 w-12 cursor-pointer items-center justify-center rounded-full bg-white shadow-md transition-transform duration-300 ease-out sm:h-14 sm:w-14 dark:bg-gray-800 dark:shadow-[0_10px_30px_rgba(0,0,0,0.4)]">{t5}{t6}</button>;
    $[5] = t4;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== t3 || $[8] !== t7) {
    t8 = <div className="scroll-to-top fixed bottom-[calc(1rem+env(safe-area-inset-bottom))] right-[calc(1rem+env(safe-area-inset-right))] z-30 flex flex-col items-center gap-6 sm:bottom-[calc(2rem+env(safe-area-inset-bottom))] sm:right-[calc(2rem+env(safe-area-inset-right))]">{t2}<div className={t3}>{t7}</div></div>;
    $[7] = t3;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  return t8;
}
function _temp() {
  window.scrollTo({
    top: 0,
    behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "instant" : "smooth"
  });
}